import { render, staticRenderFns } from "./BotonesAgendar.html?vue&type=template&id=190a7254&"
import script from "./BotonesAgendar.vue?vue&type=script&lang=js&"
export * from "./BotonesAgendar.vue?vue&type=script&lang=js&"
import style0 from "./BotonesAgendar.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports